import { useState } from 'react'

export interface PlaygroundTab {
  title: string
  content: React.ReactNode
}

export function PlaygroundTabbedTile({
  tabs,
  className,
}: {
  tabs: PlaygroundTab[]
  className?: string
}) {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <div
      className={`bg-card border border-border rounded-lg overflow-hidden flex flex-col ${className ?? ''}`}
    >
      <div className="flex border-b border-border">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`px-4 py-3 text-sm font-medium transition-colors ${
              activeTab === index
                ? 'text-foreground border-b-2 border-primary'
                : 'text-muted-foreground hover:text-foreground'
            }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="flex-1 p-4 overflow-auto">{tabs[activeTab]?.content}</div>
    </div>
  )
}
